export default "<p>\n  {{el.value}}\n</p>\n";